import type {
  UiCreateRole,
  ApiRoleUser,
  UiRoleUser,
  ApiRole,
  UiRole,
} from '../../schemas/roles.schema';

import { mapTranslationsFromApi } from './translations.mappers';
import { mapPermissionsToApi } from './permissions.mappers';

export function mapRoleUserFromApi(apiRoleUser: ApiRoleUser): UiRoleUser {
  return {
    label: apiRoleUser.name,
    value: apiRoleUser.id,
  };
}

export function mapRoleFromApi(apiRole: ApiRole): UiRole {
  return {
    id: apiRole.id,
    createdAt: apiRole.createdAt,
    key: apiRole.key,
    organizationId: apiRole?.organizationId,
    permissions: apiRole.permissions,
    translations: mapTranslationsFromApi(apiRole.translations),
    updatedAt: apiRole.updatedAt,
    users: apiRole.users?.map(mapRoleUserFromApi) || [],
  };
}

export function mapRoleToApi(role?: UiCreateRole) {
  const permissionKeys: string[] = mapPermissionsToApi(role?.permissionKeys);
  return {
    permissionKeys,
    translations:
      role?.translations?.map((translation) => ({
        locale: translation.locale?.[0]?.value,
        name: translation.name,
      })) ?? [],
    users: role?.users?.map((user) => user.value),
  };
}
